import './ScreenHolder.css'

function ScreenHolder({ children }) {
    
    return (
        <div className='screen_holder'>{children}</div>
    )
}

export default ScreenHolder